export class GoldenRecordAccountMappingDto {
  accountId: string;
  externalAccountCode: string;
}
